import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
// 引入行政区域代码划分选择页面
import AdministrativeArea from "../../components/administrativeAreaChoose/index.vue";
export default {
   // 注册组件
   components: {
    // 行政区域代码划
    AdministrativeArea,
  },
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        chineseName: null, // 中文简称
        englishName: null, // 英文简称
        twoCharCode: null, // 两字符代码
        threeCharCode: null, // 三字符代码
        numberCode: null, // 数字代码
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        chineseName: null, // 中文简称
        englishName: null, // 英文简称
        twoCharCode: null, // 两字符代码
        threeCharCode: null, // 三字符代码
        numberCode: null, // 数字代码
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      id: null, // 传递的id
      controllerFlg: null, // 页面类型
      activeName: null, // 一览切换name
    };
  },

  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 获取标识
    this.controllerFlg = this.$route.query.type;
    // 获取切换name
    this.activeName = this.$route.query.activeName;
    // 获取切换id
    this.id = this.$route.query.id;
    // 判断
    if(this.activeName === "1"){
      // 更换显示内容
      this.formConfigList = FormConfig.configList();
    }else{
      // 表单对象
      this.form = {
        id: null, // 主键
        parentAreaCode: null, // 上级行政区分代码
        parentAreaName: null, // 上级行政区域
        areaCode: null, // 行政区域代码
        areaName: null, // 行政区域名称
        levelNum: null, // 行政级别
      };
      // 更换显示内容
      this.formConfigList = FormConfig.administrativeArea();
    }
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 获取详情信息
      this.fun_Details();
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
    // 如果是修改
    else if (this.controllerFlg == "update") {
      // 获取详情信息
      this.fun_Details();
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction(`/${this.activeName === '1' ? 'nationalNameCode' : 'administrativeArea'}/detail`, {
        id: this.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * @description 保存或修改
     * @author
     */
    fun_SaveOrUpdate() {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 请求
          fun_PostAction(`/${this.activeName === '1' ? 'nationalNameCode' : 'administrativeArea'}/saveOrUpdate`, {
            ...this.form, // form表单数据
            controllerFlg: this.controllerFlg // 操作标志
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 如果页面验证失败
              if (data != null && data != "") {
                // 返回错误消息
                this.errRules = data;
                // 请求失败，弹出失败msg的消息提示
                this.$message.error("您输入的数据存在错误！");
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            }
            // 关闭loading
            this.loading = false;
          });
        } else {
          // 关闭loading
          this.loading = false;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
     /**
     * 行政区域代码选择
     */
     fun_GetAdministrativeArea(){
      // 打开弹窗
      this.$refs.administrativeArea.dialogVisible = true;
      // 请求接口
      this.$refs.administrativeArea.fun_GetOpen();
    },
    /**
     * @description 下拉框
     * @param {e} 选中的value值
     * @author 滕威
     */
    fun_GetSelectVal(e, i) {
      // 下拉框赋值
      this.form[i] = e;
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
